module.exports = function getResource(label, vars = []) {
    const resources = {
        guestCheckoutMessage: 'Guest Checkout',
        createAccountCheckoutMessage: 'Create an Account',
        youCanJoinMessage: 'You can join our free loyalty program after completing checkout.',
        joinBeautyInsiderMessage: 'Join the Beauty Insider loyalty program for free! It\'s your ticket to savings, samples and more.',
        continueGuestButton: 'Continue As Guest',
        createAccountButton: 'Create Account',
        checkOutAsAGuestLink: 'Check Out as a Guest',
        freeBirthdayGift: 'Free\nBirthday Gift',
        seasonalSavingsEvents: 'Seasonal\nSavings Events',
        sampleRewards: 'Sample\nRewards',
        bankYourBeautyPoints1: 'Bank those',
        bankYourBeautyPoints2: `${vars[0]} points`,
        bankYourBeautyPoints3: '- and enjoy great benefits - by joining Beauty Insider, our FREE loyalty program.'
    };

    return resources[label];
};
